import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./Error.scss";

const Error = ({msg}) => {
    const [lang] = useState(
      sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
    );
    // const { t } = useTranslation();
    // const isArabicLang = lang === "ar";
    return (
        <div className='errormain'>
            {/* <div className='error-inc'>
                <i className="fa-solid fa-circle-exclamation"></i>
            </div> */}
            <div className= "error-msg"><i className="fa-solid fa-circle-exclamation "></i> {msg}</div>
        </div>
    );
}

export default Error;
